export const useProductTypesStore = defineStore('productTypes', {
  state: () => ({
    productTypes: null as PaginatedProductType | null,
  }),
  getters: {
    getProductTypes: (state) => (state.productTypes !== null ? state.productTypes.items : []),
  },
  actions: {
    setProductTypes(productTypes: PaginatedProductType) {
      useLocalStorage().setItem('productTypes', productTypes);
      this.productTypes = productTypes;
    },
    async createProductType(
      productType: ProductTypeCreateUpdate,
    ): Promise<ProductType | undefined> {
      try {
        const {data} = await apiPostProductType(productType);
        pushDataToPaginatedState(this.productTypes, data);
        return data as ProductType;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductTypes({
      offset,
      limit,
      search,
    }: {offset?: number; limit?: number; search?: string} = {}): Promise<
      PaginatedProductType | undefined
    > {
      // Parse the local storage value & set the state.
      const localStorageProductTypes: PaginatedProductType | null =
        useLocalStorage().getItem('productTypes');
      if (localStorageProductTypes) this.setProductTypes(localStorageProductTypes);
      try {
        const {data} = await apiGetProductTypes(limit, offset, search);
        this.setProductTypes(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductTypeById(id: string | number): Promise<ProductType | undefined> {
      // Parse & return the local storage value.
      const localStorageProductTypes: PaginatedProductType | null =
        useLocalStorage().getItem('productTypes');
      if (localStorageProductTypes) {
        const foundProductType = localStorageProductTypes.items.find((pt) => pt.id === id);
        if (foundProductType !== undefined) return foundProductType;
      }
      try {
        const {data} = await apiGetProductType(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateProductType(
      productType: ProductTypeCreateUpdate,
    ): Promise<ProductType | undefined> {
      try {
        const response = await apiPutProductType(productType);
        const data: ProductType = response.data;
        // Find & update the target object.
        if (this.productTypes !== null) {
          const index = this.productTypes.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.productTypes.items[index], data);
            useLocalStorage().setItem('productTypes', this.productTypes);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductType(id: string | number) {
      try {
        await apiDeleteProductType(id);
        // Find & remove the element.
        if (this.productTypes !== null) {
          const index = this.productTypes.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.productTypes.items.splice(index, 1);
            useLocalStorage().setItem('productTypes', this.productTypes);
          }
          this.productTypes.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
